import { useTranslation } from 'react-i18next';
var Markdown = require('react-remarkable');

const ModalTerms = ({ modal, setModal }) => {
    const { t, i18n } = useTranslation();
    return (
        <div className="modal" tabIndex="-1" style={{ display: modal.show ? "block" : "none" }}>
            <div className={`modal-dialog ${modal.size}`}>
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="btn-close" onClick={() => { setModal({ ...modal, show: false }) }} aria-label="Close"></button>
                    </div>
                    <div className="modal-body" style={{ direction: (i18n.resolvedLanguage === 'ar' && i18n.exists("retro", { lng: i18n.resolvedLanguage, fallbackLng: i18n.resolvedLanguage }) === false) ? "ltr" : "" }}>
                        <Markdown>{modal.body}</Markdown>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-loropiana-vivid" onClick={() => { setModal({ ...modal, show: false }) }}>{t("exit")}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalTerms;